module.exports = __webpack_public_path__ + "img/bgthird.57435ea1.png";